// extracted by mini-css-extract-plugin
module.exports = {"sort":"QU","sortSelect":"RU","disabled":"SU"};